import React from 'react';
import { Layout } from 'fronton-react';
import {
  HeaderSection,
  HeaderSectionText,
  SectionTitle,
  Typography,
} from 'common/components';
import { STORAGE_CDN_PATH } from '../../storage-constants';
import { StorageCategories } from '../../components/storage-categories';
import {
  headerCategories,
  headerImage,
  headerSection,
  headerSectionDescription,
  headerSectionText,
  headerSectionTitle,
  headerSectionWrapper,
} from './storage-black-header-styles';

export const StorageBlackHeader = () => (
  <div className={headerSection}>
    <Layout className={headerSectionWrapper}>
      <HeaderSection
        bgColor="#21282B"
        hasPattern={false}
        headerContent={(
          <HeaderSectionText className={headerSectionText}>
            <SectionTitle as="h1" className={headerSectionTitle} color="text-invert" size="extra">
              БЕСПЛАТНОЕ ПРОЕКТИРОВАНИЕ СИСТЕМ ХРАНЕНИЯ В&nbsp;ЛЕМАНА ПРО
            </SectionTitle>
            <Typography className={headerSectionDescription} variant="m" size="body_long" color="text-invert">
              Поможем выбрать мебель и сделаем  дизайн-проект для удобного хранения  ваших вещей. Бережно доставим  и установим.
            </Typography>
          </HeaderSectionText>
        )}
        img={{
          alt: 'Изображение кухни',
          className: headerImage,
          ldSrcSet: `${STORAGE_CDN_PATH}/header/c/header-ld.png/header-ld-01.png`,
          dSrcSet: `${STORAGE_CDN_PATH}/header/c/header-d.png/header-d-01.png`,
          tSrcSet: `${STORAGE_CDN_PATH}/header/c/header-t.png/header-t-01.png`,
          mSrcSet: `${STORAGE_CDN_PATH}/header/c/header-m.png/header.png`,
        }}
        mediaType="image"
      />
    </Layout>
    <Layout className={headerCategories}>
      <StorageCategories variant='C' />
    </Layout>
  </div>
);
